import styled, { keyframes } from 'styled-components'

const rotation = keyframes`
  0% {
        transform: rotate(0deg);
  }
  100% {
        transform: rotate(360deg);
  }
`

export const CustomSpinner = styled.span`
  width: ${({ size }) => `${size || 64}px`};
  height: ${({ size }) => `${size || 64}px`};
  border-width: 4px;
  border-style: solid;
  border-color: ${({ color }) => color || '#007bff'};

  border-radius: ${({ size }) => `${(size || 64) / 2}px`};
  border-bottom-color: transparent;

  display: inline-block;
  box-sizing: border-box;
  animation: ${rotation} 1s linear infinite;
`
